import StateOffcanvas from '../Offcanvas'
import { InputGroup } from 'react-bootstrap'
import NamedCheckbox from '../NamedCheckbox'
import { useSettings } from 'Settings'
import HexInput from 'HexInput'
import { GroupSelect } from 'GroupSelect'

const edge_options = [
	{ value : 0, label : 'falling edge'},
	{ value : 1, label : 'rising edge'},
	{ value : 2, label : 'both edges'}
]

const sda_options = [
	{ value : 0, label : 'Standard and fast I2C mode and high speed mode if VSUP < 1.8V'},
	{ value : 1, label : 'High speed mode if VSUP > 1.8V'}
]

export function GreyPanel({ handle, onHide }) {
	const [settings] = useSettings()
	const wakeup = settings['wakeup']

	return (
		<StateOffcanvas handle={handle} onHide={onHide} trigger="grey" title="Wake Up Settings">
			<NamedCheckbox
				name="de-bouncer"
				value={wakeup['de-bouncer'].value}
				onChange={(e) => wakeup['de-bouncer'].setValue(e.target.checked)}
			/>
			<InputGroup className="mb-3">
				<InputGroup.Text>I2C Address</InputGroup.Text>
				<HexInput
					value={wakeup['i2c_address'].value}
					onChange={(e) => wakeup['i2c_address'].setValue(Math.max(0, Math.min(e.target.number, 0x7f))) }
				/>
			</InputGroup>
			<NamedCheckbox
				name="3 Wire Interface"
				value={wakeup['3 wire interface'].value}
				onChange={(e) => wakeup['3 wire interface'].setValue(e.target.checked)}
			/>
			<GroupSelect
				options={edge_options}
				name="Wake-up on"
				value={wakeup['edge'].value}
				onChange={(v) => wakeup['edge'].setValue(v.value)}
			/>
			<GroupSelect
				options={sda_options}
				name="MOSI / SDA Slopectrl"
				value={wakeup['sda'].value}
				onChange={(v) => wakeup['sda'].setValue(v.value)}
			/>
		</StateOffcanvas>
	)
}
